import { BodyComponentConsts, ItemTableConsts } from 'client/util/Constants';

const { columnTypes } = ItemTableConsts;

/**
 * This object lists the column options available for the system item table
 * @param {Object} bodyComponent - The component to be rendered for that column
 * @param {String} dataField - The path of the field to retrieve the value
 * @param {String} name - Then name of the column
 * @param {String} sortBy - The field on which the data should be sorted for this column
 */
const metadata = {
  agentVersion: {
    dataField: 'agentVersion',
    name: 'Agent Version',
  },
  created: {
    bodyComponent: 'FormattedDate',
    bodyComponentProps: {
      type: BodyComponentConsts.formattedDateTypes.systemCreated,
    },
    classNames: {
      body: [columnTypes.dateColumn],
      heading: [columnTypes.dateColumn],
    },
    name: 'Created',
    sortBy: '-created',
  },
  fileSystem: {
    dataField: 'fileSystem',
    name: 'File System Type',
  },
  groups: {
    bodyComponent: 'SystemUserGroupCount',
    name: 'Groups',
  },
  hasServiceAccount: {
    dataField: 'hasServiceAccount',
    name: 'Has Service Account',
  },
  lastContact: {
    bodyComponent: 'FormattedDate',
    bodyComponentProps: {
      type: BodyComponentConsts.formattedDateTypes.systemLastContact,
    },
    classNames: {
      body: [columnTypes.dateColumn],
      heading: [columnTypes.dateColumn],
    },
    name: 'Last Contact',
    sortBy: '-active -lastContact',
  },
  mfaStatus: {
    bodyComponent: 'StatusIcon',
    bodyComponentProps: {
      type: BodyComponentConsts.statusIconTypes.systemMfa,
    },
    classNames: {
      body: [columnTypes.mfaStatusColumn],
      heading: [columnTypes.mfaStatusColumn],
    },
    name: 'MFA Status',
    sortBy: '-allowMultiFactorAuthentication',
  },
  modifySSHDConfig: {
    dataField: 'modifySSHDConfig',
    name: 'Allow SSHD Config',
  },
  name: {
    bodyComponent: 'ItemName',
    bodyComponentProps: {
      titleField: 'displayName',
      subtitleField: 'amazonInstanceID',
    },
    classNames: {
      body: [columnTypes.nameColumn],
      heading: [columnTypes.nameColumn],
    },
    name: 'Device Name',
    sortBy: 'displayName',
  },
  nameWithLink: {
    bodyComponent: 'ItemName',
    bodyComponentProps: {
      showAsLink: true,
      titleField: 'displayName',
      subtitleField: 'amazonInstanceID',
    },
    classNames: {
      body: [columnTypes.nameColumn],
      heading: [columnTypes.nameColumn],
    },
    name: 'Device Name',
    sortBy: 'displayName',
  },
  os: {
    bodyComponent: 'SystemOSIcon',
    classNames: {
      body: [columnTypes.osColumn],
      heading: [columnTypes.osColumn],
    },
    name: 'OS',
    sortBy: 'os',
  },
  primaryAdapterIp: {
    bodyComponent: 'PrimaryAdapterIP',
    classNames: {
      body: ['ipColumn'],
      heading: ['ipColumn'],
    },
    name: 'Primary Adapter IP',
  },
  recoveryKey: {
    bodyComponent: 'ViewRecoveryKeyButton',
    classNames: {
      body: ['viewRecoveryKeyColumn'],
      heading: ['viewRecoveryKeyColumn'],
    },
    name: 'RECOVERY KEY',
  },
  serialNumber: {
    dataField: 'serialNumber',
    name: 'Serial Number',
  },
  sshPasswordAccess: {
    dataField: 'allowSshPasswordAuthentication',
    name: 'SSH Password Access',
  },
  sshPublicKeyAccess: {
    dataField: 'allowPublicKeyAuthentication',
    name: 'SSH Public Key Access',
  },
  sshRootEnabled: {
    dataField: 'sshRootEnabled',
    name: 'SSH Root Enabled',
  },
  sshRootLogin: {
    dataField: 'allowSshRootLogin',
    name: 'SSH Root Login',
  },
  status: {
    bodyComponent: 'StatusIcon',
    bodyComponentProps: {
      type: BodyComponentConsts.statusIconTypes.system,
    },
    classNames: {
      body: [columnTypes.statusColumn],
      heading: [columnTypes.statusColumn],
    },
    name: 'Status',
    sortBy: 'active',
  },
  sudo: {
    bodyComponent: 'SystemSudoStatus',
    bodyComponentProps: {
      showNewWorkflow: true,
      // NOTE: This is a placeholder. Viewport must be defined properly when this column is used!
      viewport: {},
    },
    name: 'Permissions',
  },
  validSecureToken: {
    dataField: 'serviceAccountState.hasSecureToken',
    name: 'Secure Token Granted',
  },
  validODPassword: {
    dataField: 'serviceAccountState.passwordODValid',
    name: 'Valid Local Password',
  },
  passwordAPFSValid: {
    dataField: 'serviceAccountState.passwordAPFSValid',
    name: 'Valid Disk Password',
  },
};

Object.keys(metadata).forEach((key) => {
  metadata[key].headingText = metadata[key].name;
});

export const mainPanelSystemItemTableColumnOptions = [
  metadata.agentVersion,
  metadata.created,
  metadata.fileSystem,
  metadata.hasServiceAccount,
  metadata.lastContact,
  metadata.mfaStatus,
  metadata.modifySSHDConfig,
  metadata.name,
  metadata.os,
  metadata.passwordAPFSValid,
  metadata.primaryAdapterIp,
  metadata.serialNumber,
  metadata.sshPasswordAccess,
  metadata.sshPublicKeyAccess,
  metadata.sshRootEnabled,
  metadata.sshRootLogin,
  metadata.status,
  metadata.validSecureToken,
  metadata.validODPassword,
];

export default metadata;
